import { render } from "./DocumentViewerPopup.vue?vue&type=template&id=bf590f1e&scoped=true"
import script from "./DocumentViewerPopup.vue?vue&type=script&lang=js"
export * from "./DocumentViewerPopup.vue?vue&type=script&lang=js"

import "./DocumentViewerPopup.vue?vue&type=style&index=0&id=bf590f1e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf590f1e"]])

export default __exports__